// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"EditDistributionPanelForm_checkboxContainer__3Jwxj","slotsError":"EditDistributionPanelForm_slotsError__1NwHb"};